import { createSlice } from "@reduxjs/toolkit";

export const rewardSlice = createSlice({
  name: "reward",
  initialState: {
    isBadgesLoading: true,
    isAutomationsLoading: true,
    render: 1,
    achievements: [],
    badges: {
      data: [],
      meta: null,
    },

    automations: {
      data: [],
      meta: null,
    },
  },
  reducers: {
    setIsBadgesLoading: (state, action) => {
      state.isBadgesLoading = action.payload;
    },
    setBadges: (state, action) => {
      state.badges.data = action.payload.data;
      state.badges.meta = action.payload.meta;
    },

    setIsAutomationsLoading: (state, action) => {
      state.isAutomationsLoading = action.payload;
    },
    setAutomations: (state, action) => {
      state.automations.data = action.payload.data;
      state.automations.meta = action.payload.meta;
    },
    updateAutomations: (state, action) => {
      let data = [...state.automations.data];
      data[action.payload.index].offOn = action.payload.checkedValue;
      state.automations.data = data;
    },
    setAchievements: (state, action) => {
      state.achievements = action.payload;
    },
    setRender: (state, action) => {
      state.render = action.payload;
    },
  },
});

export const {
  setIsBadgesLoading,
  setBadges,
  setIsAutomationsLoading,
  setAutomations,
  updateAutomations,
  setAchievements,
  setRender,
} = rewardSlice.actions;

export default rewardSlice.reducer;
